
<template>
  <div>
    <div class="find">
      <div class="seach-top">
        <el-form
          ref="searchForm"
          :inline="true"
          :model="searchForm"
          class="demo-form-inline"
        >
          <el-form-item
            label="关键字："
          >
            <el-input
              v-model="searchForm.keyWord"
              placeholder="请输入查询关键字"
              size="small"
              clearable
            />
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="searchForm.NotifyTypeDictKey"
              clearable
              filterable
              placeholder="请选择类别"
              size="small"
              @change="handleSearch"
            >
              <el-option
                v-for="item in getComboxData('D88')"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="small"
              @click="handleSearch"
            >
              查询
            </el-button>
          </el-form-item>

        </el-form>
      </div>
    </div>

    <el-table
      class="table-list"
      :border="true"
      :data="tableData"
      style="width: 100%"
      @sort-change="handleResort"
    >
      <!-- 序号 -->
      <el-table-column label="序号" type="index" width="50px" align="right" />

      <!-- 状态 -->
      <el-table-column
        prop="isRead"
        label="状态"
        width="100"
        align="center"
      >
        <template slot-scope="scope">
          <i v-if="scope.row.isRead" class="el-icon-folder-opened" />
          <i v-else class="el-icon-folder" />
        </template>
      </el-table-column>

      <!-- 来自 -->
      <el-table-column
        prop="fromUserName"
        label="来自"
        width="100"
        align="center"
      />

      <!-- 时间 -->
      <el-table-column
        prop="notifyDtShow"
        label="时间"
        width="180"
        align="center"
      />

      <!-- 通知类型 -->
      <el-table-column
        prop="notifyTypeDictName"
        label="通知类型"
        width="120"
        align="left"
      />

      <!-- 标题 -->
      <el-table-column
        prop="title"
        label="标题"
        width="220"
        align="left"
      />

      <!-- 内容 -->
      <el-table-column
        prop="content"
        label="内容"
        mix-width="200"
        align="left"
      />

      <!-- 链接 -->
      <el-table-column
        prop="noticeLink"
        label="操作"
        width="120"
        align="center"
      >
        <template slot-scope="scope">
          <el-button v-if="scope.row.notifyTypeDictKey ==='D8801' && scope.row.isRengling" type="text" size="small" @click.native.prevent="handleToKeti(scope.row)">
            进入课题
          </el-button>
          <el-button v-if="scope.row.notifyTypeDictKey ==='D8801' && !scope.row.isRengling" type="text" size="small" @click.native.prevent="handleRenLing(scope.row)">
            认领
          </el-button>

          <el-button
            v-if="scope.row.notifyTypeDictKey ==='D8802'"
            type="text"
            size="small"
            @click.native.prevent="handleDtl02(scope.row)"
          >
            详情
          </el-button>

          <el-button
            v-if="scope.row.notifyTypeDictKey ==='D8803'"
            type="text"
            size="small"
            @click.native.prevent="handleDtl03(scope.row)"
          >
            审核/跟进
          </el-button>
          <el-button
            v-if="scope.row.notifyTypeDictKey ==='D8804'"
            type="text"
            size="small"
            @click.native.prevent="handleDtl04(scope.row)"
          >查看</el-button>
          <el-button
            v-if="scope.row.notifyTypeDictKey ==='D8805'"
            type="text"
            size="small"
            @click.native.prevent="handleDtl05(scope.row)"
          >查看</el-button>
          <el-button
            v-if="scope.row.notifyTypeDictKey ==='D8806'"
            type="text"
            size="small"
            @click.native.prevent="handleDtl06(scope.row)"
          >
            详情
          </el-button>
        </template>
      </el-table-column>

    </el-table>
    <el-pagination
      background
      layout="prev, pager, next,total,sizes"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="10"
      :total="totalCount"
      @size-change="handleSizeChange"
      @current-change="handleChangePage"
    />

    <WorkEventNodeFollow
      v-model="nodeFollowShow"
      :node-key="nodeKey"
      :follow-type="followType"
      @save-success="handleSearch"
    />
    <ReplyMsg ref="replymsg" />
    <TaskFollow ref="followForm" :entity-id="taskId" :module-code="moduleCode" :module-key="moduleKey" @ToEdit="(id)=>{handleToTaskEdit(id)}" />
    <TaskAudit ref="auditForm" :entity-id="taskId" :module-code="moduleCode" :module-key="moduleKey" />
    <TaskEdit ref="editForm" :entity-id="taskId" :module-code="moduleCode" :module-key="moduleKey" />
    <Notice02Info ref="notice02Info" />
    <Notice01Info ref="notice01Info" />
  </div>
</template>

<script>
import pathReq from '@/api/pathlist'
import KxjCom from '@/utils/kxjcom'
import WorkEventNodeFollow from '@/views/managesystem/gz/com/WorkEventNodeFollow'
import ReplyMsg from '@/views/managesystem/gz/com/MemberReplyMsg'
import TaskFollow from '@/views/managesystem/gz/com/WorkTaskFollow'
import TaskAudit from '@/views/managesystem/gz/com/WorkTaskAudit'
import TaskEdit from '@/views/managesystem/gz/com/WorkTaskEdit'
import Notice01Info from './headernotice01Info.vue'
import Notice02Info from './headernotice02Info.vue'
export default {
  components: {
    WorkEventNodeFollow, ReplyMsg, TaskFollow, TaskAudit, TaskEdit, Notice01Info, Notice02Info
  },
  filters: {
    dateFmt(val) {
      return KxjCom.tableDateFormat(val)
    },
    decFmt(val) {
      return KxjCom.tableDecFormat(val)
    },
    dateTimeFmt(val) {
      return KxjCom.tableDateTimeFormat(val)
    }
  },
  data() {
    return {
      totalCount: 0,
      tableData: [],
      allComboxData: [],
      searchForm: {
        pageNumber: 1,
        pageSize: 10,
        sortKey: '',
        sortOrder: '',
        keyWord: '',
        NotifyTypeDictKey: ''
      },
      // moduleCode: '',
      // moduleKey: null,
      // currentEventKey: null,
      nodeKey: null,
      followType: null,
      nodeFollowShow: false,
      taskId: null,
      moduleCode: '',
      moduleKey: null
    }
  },
  // 画面激活
  activated() {
    this.handleSearch()
  },
  // 初期化数据
  created() {
    // 绑定检索
    this.$bus.$off('handleReload')
    this.$bus.$on('handleReload', this.handleSearch)

    /** 下拉框数据 */
    pathReq.getComboxDatasByIdArray('D88').then(res => {
      this.allComboxData = res.data.result
    })
  },
  mounted() {},
  methods: {
    // combox筛选值
    getComboxData(typeId) {
      return this.allComboxData.filter(function(item) {
        return item.typeId === typeId
      })
    },
    // 每页
    handleSizeChange(val) {
      this.searchForm.pageSize = val
      this.handleSearch()
    },
    // 切页
    handleChangePage(page) {
      this.searchForm.pageNumber = page
      this.handleSearch()
    },
    // 排序
    handleResort(column) {
      this.searchForm.sortKey = column.prop
      this.searchForm.sortOrder = column.order
      this.handleSearch()
    },
    // 查询
    handleSearch() {
      const that = this
      const loading = this.$loading(KxjCom.loadOptions)
      var path = '/api/services/app/WorkNotification/GetPagedListWorkEvents'
      pathReq
        .getList(path, that.searchForm)
        .then(res => {
          loading.close()
          that.totalCount = res.data.result.totalCount
          that.tableData = res.data.result.items
        })
    },
    /** 认领 */
    handleRenLing(row) {
      const path = '/api/services/app/WorkNotification/DoNotifyRead'
      if (!row.isRead) {
        pathReq.postForm(path, { id: row.id })
      }
      // this.$router.push({
      //   name: row.moduleCode
      // })
      this.$refs.notice01Info.show(row.moduleCode, row.moduleKey)
    },
    /** 进入课题 */
    handleToKeti(row) {
      console.log(row)
      this.$router.push({
        name: row.moduleCode + 'dtl',
        params: {
          id: row.moduleKey,
          moduleCode: row.moduleCode
        }
      })
    },
    /** 好友邀请详情 */
    handleDtl02(row) {
      const path = '/api/services/app/WorkNotification/DoNotifyRead'
      if (!row.isRead) {
        pathReq.postForm(path, { id: row.id })
      }
      // this.$router.push({
      //   name: 'td01'
      // })
      this.$refs.notice02Info.show(row.id, row.detailJson)
    },
    /** 事件审核通知 */
    handleDtl03(row) {
      const that = this
      this.taskId = row.eventKey
      this.moduleCode = row.moduleCode
      this.moduleKey = row.moduleKey

      let path = '/api/services/app/WorkNotification/DoNotifyRead'
      if (!row.isRead) {
        pathReq.postForm(path, { id: row.id })
      }
      // 判断是审核还是跟进
      path = '/api/services/app/WorkTask/HasPerAudit'
      pathReq.postForm(path, { id: that.taskId }).then(r => {
        if (r.data.result) {
          this.$refs.auditForm.show()
        } else {
          this.$refs.followForm.show()
        }
      })
    },
    /** 好友私信 */
    handleDtl04(row) {
      const path = '/api/services/app/WorkNotification/DoNotifyRead'
      if (!row.isRead) {
        pathReq.postForm(path, { id: row.id })
      }
      this.$refs.replymsg.showDialog(row.msgRootId ?? row.id)
    },
    /** 任务提醒 */
    handleDtl05(row) {
      this.taskId = row.eventKey
      this.moduleCode = row.moduleCode
      this.moduleKey = row.moduleKey

      this.$refs.followForm.show()
    },
    /** 查看日程通知 */
    handleDtl06(row) {
      const path = '/api/services/app/WorkNotification/DoNotifyRead'
      if (!row.isRead) {
        pathReq.postForm(path, { id: row.id })
      }
      this.taskId = row.eventKey
      this.moduleCode = row.moduleCode
      this.moduleKey = row.moduleKey

      this.$refs.followForm.show('tab05')
    },
    /** 任务编辑 */
    handleToTaskEdit(id) {
      var row = this.tableData.find(x => x.eventKey === id)
      if (row) {
        this.taskId = row.eventKey
        this.moduleCode = row.moduleCode
        this.moduleKey = row.moduleKey
        this.$refs.editForm.show()
      }
    }

  }
}
</script>

<style scoped>
/* ffc059 */
</style>
